import { useReducer } from 'react'

export default function useToggle(initialValue) {
    return useReducer((x, y) => (typeof y === 'boolean' ? y : !x), initialValue)
}
